import React, { useEffect, useState } from "react";
import useInfiniteScroll, { FEED_PAGE_SIZE } from "../../hooks/useInfiniteScroll";
import { T } from "../Translate";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../../firebase"; // Asegúrate de configurar tu archivo firebase
import {
  collection,
  doc,
  getDocs,
  getDoc,
  query,
  where,
} from "firebase/firestore";
import {
  Button,
  TextField,
  Box,
  Skeleton,
  Grid,
  Container,
  AppBar,
  CardMedia,
  Toolbar,
  Typography,
  InputAdornment,
} from "@mui/material";
import { Search as SearchIcon } from "../../icons";
import { DirectionsCar as DirectionsCarIcon } from "../../icons";
import "react-date-picker/dist/DatePicker.css";
import Atras from "../BackButton";
import BottomNav from "../BottomToolbar";
import { brandColors, barColors } from "../../theme";
import { pageContentSx } from "../../pageLayout";

import SearchClearAdornment from "../../components/SearchClearAdornment";
const VehiclesComponent = () => {
  const [cars, setCars] = useState([]);
  // Arranca en true: el fetch inicial recién pone loading en true dentro del
  // efecto de mount, así que si arrancara en false se vería un flash de
  // contenido vacío antes del Skeleton.
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const isLoggedIn = () => {
    return !!auth.currentUser;
  };

  const getToken = async () => {
    if (auth.currentUser) {
      return auth.currentUser.getIdToken();
    }
    return null;
  };

  useEffect(() => {
    const checkAuthAndFetchVehiculos = async () => {
      if (!isLoggedIn()) {
        navigate("/login");
        return;
      }

      try {
        const token = await getToken();
        if (!token) {
          console.error("No se pudo obtener el token de autenticación.");
          return;
        }

        const currentUser = auth.currentUser;
        if (!currentUser) {
          console.error("No hay un usuario autenticado.");
          return;
        }

        setLoading(true);
        const { uid } = currentUser;

        // Query the 'vehiculos' collection for entries matching the user's uid
        const vehiculosQuery = query(
          collection(db, "vehiculos"),
          where("uid", "==", uid)
        );
        const vehiculosSnapshot = await getDocs(vehiculosQuery);

        const vehiculoPromises = vehiculosSnapshot.docs.map(
          async (vehiculoDoc) => {
            const vehiculoData = vehiculoDoc.data();
            const carRef = doc(db, "cars", vehiculoData.autoId); // Assuming 'vehiculoId' in 'vehiculos' refers to the car ID
            const carDoc = await getDoc(carRef);

            if (carDoc.exists()) {
              const carData = carDoc.data();
              let imageUrls = [];
              if (carData.images && Array.isArray(carData.images)) {
                imageUrls = carData.images;
              } else if (carData.images && typeof carData.images === "string") {
                imageUrls = [carData.images];
              }
              return {
                ...carData,
                id: carDoc.id,
                imageUrls: imageUrls,
                createdAt: carData.createdAt.toDate(),
              };
            } else {
              return null; // Or handle the case where the car is not found
            }
          }
        );

        const vehiculosData = await Promise.all(vehiculoPromises);
        setCars(vehiculosData.filter((car) => car !== null)); // Filter out any null values

        setLoading(false);
      } catch (error) {
        console.error("Error al obtener vehiculos:", error);
        setLoading(false);
      }
    };

    checkAuthAndFetchVehiculos();
  }, [navigate]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Muestra los vehículos de a 13 y suma otros 13 al acercarse al último.
  const { limit: vehiclesLimit, sentinelRef: vehiclesSentinelRef } = useInfiniteScroll(searchTerm, FEED_PAGE_SIZE);

  const filteredVehiculos = cars.filter((car) => {
    const searchMatch =
      car.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      car.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
      car.price.toString().includes(searchTerm) ||
      car.city.toString().includes(searchTerm) ||
      car.modelo.toString().includes(searchTerm) ||
      car.km.toString().includes(searchTerm) ||
      car.marca.toString().toLowerCase().includes(searchTerm.toLowerCase());

    return searchMatch;
  });

  const formatDate = (timeToDo) => {
    if (timeToDo instanceof Date) {
      return timeToDo.toLocaleDateString();
    } else if (timeToDo && timeToDo.toDate instanceof Function) {
      return timeToDo.toDate().toLocaleDateString();
    }
    return "";
  };

  const handleVerClick = (carId) => {
    navigate(`/cars/${carId}`);
  };

  const styles = {
    cont: {
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      textAlign: "center",
      margin: 0,
      padding: 0,
      boxSizing: "border-box",
    },
    img: {
      maxWidth: "150px",
      maxHeight: "40px",
      display: "block",
      margin: "20px auto",
    },
    slogan: {
      color: "white",
      fontSize: "14px",
      fontWeight: "bold",
      paddingBottom: "-5px",
    },
    iconContainer: {
      display: "flex",
      width: "100%",
      borderTop: "1.5px solid black",
      justifyContent: "space-around",
      color: "black",
    },
    iconContainerL: {
      display: "flex",
      width: "100%",
      borderTop: "1.5px solid black",
      justifyContent: "space-around",
    },
    backSlogan: {
      display: "block",
      width: "100vw",
      height: "19px",
      backgroundColor: "#fff",
      textAlign: "center",
    },
    listItem: {
      display: "block",
      width: "95%",
      border: "0.5px solid #ccc",
      margin: "15px auto",
      boxShadow: "0px 0px 3px 0px black",
    },
    typography: {
      marginBottom: "0px",
    },
    contList: {
      marginTop: "-30px",
    },
    inputS: {
      width: "95%",
      height: "35px",
      marginTop: "20px",
      padding: "5px",
      fontSize: "14px",
      border: "3px solid grey",
      borderRadius: "4px",
    },

    card: {
      border: "2px solid grey",
      borderRadius: "10px",
      padding: "20px",
    },
    carde: {
      width: "100%",
      border: "1px solid #ddd",
      borderRadius: "8px",
      overflow: "hidden",
      marginBottom: "20px",
    },
    imageContainer: {
      position: "relative",
      width: "100%",
      height: "300px",
    },
    mainImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    additionalImagesOverlay: {
      position: "absolute",
      bottom: "10px",
      right: "10px",
      width: "80px",
      height: "80px",
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
      cursor: "pointer",
    },
    additionalImagesCount: {
      fontSize: "24px",
      fontWeight: "bold",
    },
    contentContainer: {
      padding: "16px",
    },
    name: {
      fontSize: "14px",
      color: "#777",
      marginBottom: "8px",
    },
    title: {
      fontSize: "24px",
      fontWeight: "bold",
      marginBottom: "8px",
    },
    description: {
      fontSize: "14px",
      marginBottom: "8px",
    },
    price: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "success.main",
      marginBottom: "8px",
    },
    place: {
      fontSize: "14px",
      color: "dodgerblue",
      marginBottom: "8px",
    },
    created: {
      fontSize: "12px",
      color: "#999",
    },
    media: {
      width: "100px",
      marginTop: "15px",
      marginBottom: "15px",
    },
    thumbnailContainer: {
      position: "relative", // To position the counter
      marginTop: "15px",
      marginBottom: "15px",
    },
    thumbnail: {
      width: "100%",
      height: "200px", // Adjust height as needed
      objectFit: "cover",
    },
    imageCount: {
      position: "absolute",
      bottom: "10px",
      right: "10px",
      backgroundColor: "rgba(0, 0, 0, 0.6)",
      color: "white",
      padding: "10px 8px",
      borderRadius: "4px",
    },
  };

  return (
    <Container maxWidth={false} disableGutters sx={pageContentSx}>
      <AppBar
        position="fixed"
        sx={{ bgcolor: barColors.background, color: barColors.text, overflowX: "hidden" }}
      >
        <Toolbar sx={{ padding: "10px 0" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: "100%",
              maxWidth: { xs: "100%", md: "980px" },
              mx: "auto",
              px: 2,
              boxSizing: "border-box",
            }}
          >
            <Atras color="inherit" />
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              <T>Mis Vehículos</T>
            </Typography>
          </Box>
        </Toolbar>
        <Box sx={{ width: "100%", borderTop: `1px solid ${barColors.border}` }}>
          <Toolbar disableGutters sx={{ width: "100%", px: 2, boxSizing: "border-box" }}>
            <Box
              sx={{
                width: "100%",
                maxWidth: { xs: "100%", md: "980px" },
                mx: "auto",
                boxSizing: "border-box",
              }}
            >
              <TextField
                placeholder="Buscar vehículo..."
                value={searchTerm}
                onChange={handleSearchChange}
                variant="outlined"
                size="small"
                fullWidth
                InputProps={{
                  endAdornment: <SearchClearAdornment value={searchTerm} onChange={handleSearchChange} />,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: barColors.textMuted }} />
                    </InputAdornment>
                  ),
                  sx: {
                    color: barColors.text,
                    backgroundColor: barColors.activeBg,
                    borderRadius: "999px",
                    "& fieldset": { border: "none" },
                    "&:hover fieldset": { border: "none" },
                    "&.Mui-focused fieldset": { border: `1px solid ${barColors.border}` },
                  },
                }}
              />
            </Box>
          </Toolbar>
        </Box>
      </AppBar>
      <Container sx={{ mt: 23 }}>
        <Box>
          {loading ? (
            <Grid container spacing={2} sx={{ mb: 20 }}>
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <Grid item key={i} xs={12} sm={6} md={4} lg={4}>
                  <Box sx={{ p: 2, backgroundColor: brandColors.backgroundPaper, border: `1px solid ${brandColors.divider}`, borderRadius: "10px" }}>
                    <Skeleton variant="text" width="70%" height={28} sx={{ mb: 1 }} />
                    <Skeleton variant="text" width="90%" height={20} />
                    <Skeleton variant="text" width="100%" height={20} />
                    <Skeleton variant="text" width="50%" height={20} sx={{ mb: 1 }} />
                    <Skeleton variant="rectangular" width="100%" height={140} sx={{ borderRadius: "8px", my: 1 }} />
                    <Skeleton variant="rectangular" width="100%" height={36} sx={{ borderRadius: "6px" }} />
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <>
              {filteredVehiculos.length > 0 ? (
                <Grid container spacing={2} sx={{ mb: 20 }}>
                  {filteredVehiculos.slice(0, vehiclesLimit).map((car) => (
                    <Grid item key={car.id} xs={12} sm={6} md={4} lg={4}>
                      <Box style={styles.card}>
                        <Typography sx={styles.title}>{car.title}</Typography>
                        <Box sx={styles.contentContainer}>
                          <Typography sx={styles.description}>
                            <T>Condicion:</T> {car.condicion}
                          </Typography>
                          <Typography sx={styles.description}>
                            {car.description}
                          </Typography>
                          <Typography sx={styles.price}>
                            <T>Precio:</T> $ {car.price}
                          </Typography>
                          <Typography sx={styles.modelo}>
                            <T>Ciudad:</T> {car.city}
                          </Typography>
                          <Typography sx={styles.modelo}>
                            <T>Modelo:</T> {car.año}
                          </Typography>
                          <Typography sx={styles.modelo}>
                            <T>Kilómetros:</T> {car.km} km
                          </Typography>
                          <Typography sx={styles.marca}>
                            <T>Marca:</T> {car.marca}
                          </Typography>
                          <Typography sx={styles.marca}>
                            <T>Linea:</T> {car.modelo}
                          </Typography>
                          <Typography sx={styles.created}>
                            <T>Fecha de publicación:</T> {formatDate(car.createdAt)}
                          </Typography>
                          <Box sx={styles.thumbnailContainer}>
                            {car.imageUrls && car.imageUrls.length > 0 ? (
                              <>
                                <CardMedia
                                  component="img"
                                  image={car.imageUrls[0]} // Display the first image
                                  alt={`Imagen de ${car.title}`}
                                  sx={styles.thumbnail}
                                />
                                {car.imageUrls.length > 1 && (
                                  <Typography sx={styles.imageCount}>
                                    +{car.imageUrls.length - 1}
                                  </Typography>
                                )}
                              </>
                            ) : (
                              <Box style={styles.noImage}>
                                <Typography>
                                  <T>No hay imágenes disponibles</T>
                                </Typography>
                              </Box>
                            )}
                          </Box>
                          <Button
                            variant="contained"
                            onClick={() => handleVerClick(car.id)}
                            fullWidth
                            sx={{ mt: 1, mb: 1 }}
                          >
                            <T>Volver a contactar</T>
                          </Button>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                  {filteredVehiculos.length > vehiclesLimit && (
                    <Grid item xs={12}>
                      <Box ref={vehiclesSentinelRef} sx={{ height: 1 }} />
                    </Grid>
                  )}
                </Grid>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    minHeight: "45vh",
                    gap: 1.5,
                    color: "text.secondary",
                  }}
                >
                  <DirectionsCarIcon sx={{ fontSize: 56, color: "text.disabled" }} />
                  <Typography sx={{ color: "text.secondary" }}>
                    <T>No encontramos publicaciones.</T>
                  </Typography>
                </Box>
              )}
            </>
          )}
          {!loading && filteredVehiculos.length > 0 && (
            <Typography
              variant="caption"
              align="center"
              sx={{ display: "block", color: brandColors.textSecondary, mt: 2, mb: 10 }}
            >
              © 2026 Dapur Tecnología - Notiline
            </Typography>
          )}
        </Box>
      </Container>
      <BottomNav />
    </Container>
  );
};

export default VehiclesComponent;
